import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges } from '@angular/core';
import { System } from '@app/core/resources/system';
import { PlatformBrowserService } from '@app/core/services/platform-browser.service';

interface IPostGhostBySystem {
    alt: string;
    title: string;
    imageUrl: string;
    titleCard: string;
    linkCard: string;
    excerpt: string;
}

@Component({
    selector: 'app-blog-by-system',
    templateUrl: './blog-by-system.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./blog-by-system.component.scss']
})
export class BlogBySystemComponent implements OnChanges {
    public postsGhostBySystem: Array<IPostGhostBySystem> = [];
    public emptyBlog: boolean = true;
    @Input() public system: System = new System();
    @Input() public systemTags: string = '';
    @Input() public title: string = '';

    public constructor(
        private httpClient: HttpClient,
        private browserService: PlatformBrowserService,
        private changeDetectorRef: ChangeDetectorRef
    ) {}

    public ngOnChanges(): void {
        if (this.browserService.isBrowser && this.systemTags) {
            if (this.system.id === '') {
                this.system.attributes.can_receive = true;
            }
            this.getPosts();
        }
    }

    private getPosts(): void {
        let urlApiBlog: string =
            'https://blog.saldo.com.ar/ghost/api/content/posts/?key=4443cb2f63ee21d65e2cb72694&filter=tag:[' +
            this.systemTags.replace(/\s+/g, '-') +
            ']';
        this.postsGhostBySystem = [];
        this.httpClient.get(urlApiBlog).subscribe((data: any) => {
            if (data.posts.length !== 0) {
                this.emptyBlog = false;
            }
            data.posts.forEach((element: any) => {
                let urlImageCard: string = 'https://img.reyesoft.com/saldo/m/' + encodeURIComponent(element.feature_image);
                this.postsGhostBySystem.push({
                    alt: element.title,
                    title: element.title,
                    imageUrl: urlImageCard,
                    titleCard: element.title,
                    linkCard: element.url,
                    excerpt: element.excerpt
                });
            });
            this.changeDetectorRef.markForCheck();
        });
    }
}
